// extracted by mini-css-extract-plugin
export var bisolduoSprey = "styles-module--bisolduoSprey--nssY2";
export var bisolduoSurup = "styles-module--bisolduoSurup--xzqUX";
export var bisolviralSprey = "styles-module--bisolviralSprey--DYiYk";
export var holder = "styles-module--holder--aHqpI";
export var image = "styles-module--image--aj2tH";
export var logo = "styles-module--logo--pJEFK";
export var multiHolder = "styles-module--multiHolder--+1hOW";
export var overpositionimage = "styles-module--overpositionimage--KXfyn";